import Vue from "vue";
import VueI18n from "vue-i18n";
import injectables from "@/_shared/lib/meta/injectables";
import { get as _get, has as _has } from "lodash";
Vue.use(VueI18n);
import axios from "axios";
export const hasInjectedLanguage = _has(injectables, ["lang"]);
const injectedMessages = _get(injectables, ["lang", "translations"]);
const injectedLocale = _get(injectables, ["lang", "locale"]);
const loadedLanguages = hasInjectedLanguage ? [injectedLocale] : [];
const config = {
  locale: hasInjectedLanguage ? injectedLocale : "en",
  // process.env.VUE_APP_I18N_LOCALE || 'en',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: hasInjectedLanguage ? injectedMessages : { en: {} },
  enableInSFC: true,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  preserveDirectiveContent: true,
};

export const i18n = new VueI18n(config);

function setI18nLanguage(lang) {
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  i18n.locale = lang;
  return lang;
}

export async function pushAndSetLocale(lang, messages) {
  await i18n.setLocaleMessage(lang, messages);
  loadedLanguages.push(lang);
  return Promise.resolve(setI18nLanguage(lang));
}

export async function fetchAndUpdateLanguage(lang, $store) {
  let route = "api/translations";
  if (lang) route += "/" + lang;

  if ((hasInjectedLanguage && i18n.locale === lang) || loadedLanguages.includes(lang)) {
    const response = await axios.get(route);
    $store.dispatch("handleLanguageChange", response.data.static);
    setI18nLanguage(lang);
    return Promise.resolve(lang);
  }

  const updateLang = await axios.get(route).then(response => {
    const lang = response.data.locale;
    pushAndSetLocale(lang, response.data.translations);
    $store.dispatch("handleLanguageChange", response.data.static);
    return Promise.resolve(lang);
  });

  return updateLang;

  // // If the language hasn't been loaded yet
  // return import(
  //     /* webpackChunkName: "lang-[request]" */ `@/admin/plugins/i18n/messages/${lang}.js`
  // ).then(messages => {
  //     i18n.setLocaleMessage(lang, messages.default);
  //     loadedLanguages.push(lang);
  //     return setI18nLanguage(lang);
  // });
}

export default i18n;
